var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimaryToAllSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8a3 3 0 102.906 3.75h4.543l1.707 5.464c.114.4.355.984.734 1.487.374.497.991 1.049 1.86 1.049H20a.753.753 0 00.093-.006 3.001 3.001 0 100-1.488.753.753 0 00-.093-.006H14.75c-.18 0-.408-.114-.662-.451a3.267 3.267 0 01-.497-1.023L11.786 11l1.805-5.776a3.266 3.266 0 01.497-1.022c.254-.337.481-.452.662-.452H20a.759.759 0 00.093-.006 3.001 3.001 0 100-1.488A.759.759 0 0020 2.25H14.75c-.869 0-1.486.552-1.86 1.049a4.762 4.762 0 00-.734 1.487L10.45 10.25H5.906A3.001 3.001 0 003 8z",
    fill: "currentColor"
  })));
}
export default SvgPrimaryToAllSolid;